<template>
  <div class="medical-record-exam">
    <div class="border-title text-center">
      <label class="form-label text-bold mb-2">Paquimetria</label>
      <div class="columns">
        <div class="column col-4 text-bold"></div>
        <div class="column col-4 text-bold">OD</div>
        <div class="column col-4 text-bold">OE</div>
      </div>
    </div>
    <div class="border-items">
      <div class="columns">
        <div class="column col-4 form-group centered"></div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.valueR"
                   step="1" min="100" max="1500"
                   placeholder="100 - 1500"
                   data-tabindex="1">
            <span class="input-group-addon">&#181;m</span>
          </div>
        </div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.valueL"
                   step="1" min="100" max="1500"
                   placeholder="100 - 1500"
                   data-tabindex="2">
            <span class="input-group-addon">&#181;m</span>
          </div>
        </div>
        <template v-if="!triage">
          <div class="column col-4 form-group centered">Laudo OD</div>
          <div class="column col-8 form-group">
            <input type="text" class="form-input"
                   v-model="form.reportR"
                   placeholder="Laudo olho direito...">
          </div>
          <div class="column col-4 form-group centered">Laudo OE</div>
          <div class="column col-8 form-group">
            <input type="text" class="form-input"
                   v-model="form.reportL"
                   placeholder="Laudo olho esquerdo...">
          </div>
        </template>
        <div class="column col-4 form-group centered">Observações</div>
        <div class="column col-8 form-group">
          <input type="text" class="form-input"
                 v-model="form.observations"
                 placeholder="Observações...">
        </div>
      </div>

      <st-entity-file-manager
        v-if="form.id"
        :entity-id="patient.id"
        :origin-id="medicalRecordId"
        :origin-child-id="form.id"
        origin-type="medical_record_exam"
        :key="medicalRecordId"
      />

      <div class="text-center btn-icon btn-icon-left mt-2">
        <button
          type="button"
          class="btn btn-info mr-2"
          :class="{ loading: saving }"
          @click="save"
        ><fa-icon :icon="['fal', 'save']" /> Salvar</button>
        <button
          type="button"
          class="btn btn-gray-outline btn-icon btn-icon-left mr-2"
          @click="$emit('cancel')"
        ><fa-icon :icon="['fal', 'times']" /> Cancelar</button>
        <button
          v-if="!triage"
          type="button"
          class="btn btn-info-outline btn-icon btn-icon-left mr-2"
          :disabled="true"
        ><fa-icon :icon="['fal', 'history']" /> Histórico</button>
        <st-button-report
          v-if="!triage"
          type="pdf"
          label="Imprimir"
          button-class="btn-gray mr-2"
          :route="printUrl"
          :options="[]"
        />
        <button
          type="button"
          class="btn btn-error btn-icon btn-icon-left"
          :class="{ loading: removing }"
          @click="promptRemoval"
        ><fa-icon :icon="['fal', 'trash']" /> Excluir</button>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from './formMixin';

/**
centralCornea(R|L): 400 - 700 µm (int) - Espessura central da córnea OD
thinnestPoint(R|L): 380 - 700 µm (int) - Ponto mais fino da córnea (OD)
inferiorThickness(R|L): 400 - 700 µm (int) - Região inferior (opcional)
superiorThickness(R|L): 400 - 700 µm (int) - Região superior
 */

export default {
  mixins: [formMixin],
  data() {
    return {
      form: {
        id: null,
        valueR: '',
        valueL: '',
        reportR: '',
        reportL: '',
        observations: '',
      },
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

</style>
